import { Tab, Box, Tabs, useTheme } from '@mui/material'
import React, { useState } from 'react'
import DashBoardGestao from '../dashboardGestao'
import PrivateRC from '../../components/PrivateRC'
import ColaboradorDashBoard from '../dashboardColaborador'

const DashboardMultiplo = () => {
  const [tab, setTab] = useState(0)
  const theme = useTheme()

  return (
    <Box sx={{ mt: 2 }}>
      <PrivateRC roles="bibliotecario">
        <Tabs
          value={tab}
          onChange={(event, newValue) => {
            setTab(newValue)
          }}
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.leitura.main
            }
          }}
        >
          <Tab onClick={() => setTab(0)} label="colaborador" />
          <Tab onClick={() => setTab(1)} label="gestão" />
        </Tabs>
      </PrivateRC>
      {tab === 0 && (
        <PrivateRC roles="leitor">
          <ColaboradorDashBoard />
        </PrivateRC>
      )}
      {tab === 1 && (
        <PrivateRC roles="bibliotecario">
          <DashBoardGestao />
        </PrivateRC>
      )}
    </Box>
  )
}

export default DashboardMultiplo
